import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import InputValueProps from '../../../../../prop-types/input-value-props';
import dangerousGoodsClassifications from '../../../../../../../../orders/other-shipping-options/constants/dangerous-goods-classifications';
import classnames from 'classnames';
import sharedStyles from '../../../../../style.module.less';
import messages from './messages';

import { INT_PARAMETER, PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from './style.module.less';

const SetOrderAsDangerousGoods = ({ inputValueProps, onChange }) => {
  const { [PARAMETER]: parameter, [INT_PARAMETER]: intParameter } = inputValueProps;
  const [contactInfo, setContactNumber] = useState(parameter);
  const onSetContactNumber = useCallback((e) => {
    setContactNumber(e?.target?.value);
  }, []);
  const onUpdateActionProperties = useCallback(
    (automationRuleId) => {
      onChange({
        [PARAMETER]: contactInfo,
        [INT_PARAMETER]: automationRuleId,
      });
    },
    [onChange, contactInfo],
  );

  const onUpdateActionContact = useCallback(() => {
    onUpdateActionProperties(intParameter);
  }, [onUpdateActionProperties, intParameter]);

  const options = [
    {
      automationRuleId: 0,
      id: 'Unknown',
      label: <FormattedMessage {...messages.dangerousGoodsClassificationUnknown} />,
    },
    ...dangerousGoodsClassifications,
  ];
  const selectedOption = options.find((opt) => opt.automationRuleId === intParameter);
  return (
    <div className={style['multi-control']}>
      <div className={style['multi-control-row']}>
        <div>
          <FormattedMessage {...messages.dangerousGoodsTypeOfGoods} />
        </div>
        <div>
          <DropdownMenu className={sharedStyles['dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
            <DropdownMenuToggler className={sharedStyles['dropdown-toggler']}>
              {selectedOption && selectedOption.label}
              {!selectedOption && <FormattedMessage {...messages.noOptionSelectedMessage} />}
            </DropdownMenuToggler>
            {options.map((option) => {
              return (
                <DropdownMenuItem
                  key={option.id}
                  className={sharedStyles['dropdown-item']}
                  onClick={() => onUpdateActionProperties(option.automationRuleId)} // TODO: remove anon when dropdown supports typing for a further nested element
                  theme='unstyled'
                >
                  {option.label}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenu>
        </div>
      </div>
      <div className={classnames(style.stacked, style['multi-control-row'])}>
        <div>
          <FormattedMessage {...messages.dangerousGoodsEmergencyContact} />
        </div>
        <div>
          <input className={style['text-input']} onBlur={onUpdateActionContact} onChange={onSetContactNumber} value={contactInfo} />
        </div>
      </div>
    </div>
  );
};

SetOrderAsDangerousGoods.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SetOrderAsDangerousGoods;
